import { NgClass } from '@angular/common'
import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core'
import { InvitationChannel } from '@app/v2/event/utils/invitation-channel-status.util'
import { ModalComponent } from '@app/v2/shared/components/modal/modal.component'

type SelectableChannelCard = {
  id: InvitationChannel
  label: string
}

const CHANNEL_CARDS: SelectableChannelCard[] = [
  { id: 'email', label: 'Email' },
  { id: 'whatsapp', label: 'WhatsApp' }
]

@Component({
  selector: 'app-select-invitation-channel-modal',
  standalone: true,
  imports: [ModalComponent, NgClass],
  templateUrl: './select-invitation-channel-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectInvitationChannelModalComponent {
  public readonly id = input.required<string>()

  public readonly channelSelected = output<InvitationChannel>()
  public readonly closed = output<void>()

  public readonly channels = CHANNEL_CARDS
  public readonly selectedChannelId = signal<InvitationChannel | null>(null)

  /**
   * Selects a channel and notifies the parent to continue the bulk-send flow.
   * @param channel - Selected channel card.
   */
  public onChannelClick(channel: SelectableChannelCard): void {
    this.selectedChannelId.set(channel.id)
    this.channelSelected.emit(channel.id)
  }

  /**
   * Resets selection when the modal is dismissed via X / backdrop and notifies the parent.
   */
  public onModalClose(): void {
    this.selectedChannelId.set(null)
    this.closed.emit()
  }
}
